import React, { Component, createRef } from 'react';
import { connect } from "react-redux";
import { Col, Container, Image } from 'react-bootstrap';
import "../../ecom/ecom.scss";
import { Link } from 'react-router-dom'
import Piechart from '../../../shared/components/charts/Piechart';
import Linegraph_sparkline from '../../../shared/components/charts/Linegraph_sparkline';
import { ChartCard } from '../../../shared/components/cards/chartcard/chartcard'
import { Carousel } from '../../../shared/components/carousel/carousel';
import '../../../shared/components/cards/card.scss'
import IconWebsite from '../../../../assets/images/icons/websiteIcon';
import MultipleValueAxes from '../../../shared/components/charts/MultipleValueAxesChart';
// import MultipleValueAxes from '../../../shared/components/charts/MultipleValueAxesChart_1';
import { DailydataDropdown } from '../../../shared/components/dropdown/dailydatadropdown';
import PieOfPieChart from "../../../shared/components/charts/PieOfPieChart";
import Wrapper from '../../../helpers/wrapper';
import DatedbasedBubbleChart from '../../../shared/components/charts/DatedbasedBubbleChart';
import DataTable from '../../../shared/components/Datatable/DataTable';
import { API_URL, API_URl } from '../../../../../constants/constants';
import { math } from '@amcharts/amcharts4/core';
import "../../../shared/components/loader/loader.scss";
import BubbleTextchart from '../../../shared/components/charts/BubbleTextchart';
import DatePicker from '../../../shared/components/datepicker/datepicker';
import IconPdf from '../../../../assets/images/icons/pdfIcon';

import StickyLogo from '../../../../assets/images/icons/icon.png'
import { Loader } from '../../../shared/components/loader/loader';
import { NoDataAvailable } from '../../../shared/components/loader/noDataAvailable';
import ChartExport from '../../../shared/components/export/ChartExport';
import '../../../layout/pageheader/pageheader.scss'
import PageHeader from '../../../../../components/layout/pageHeader';
import { CountryCode } from '../../../../../constants/countryCurrency';

export class Engagement extends Component {
	scrollDiv = createRef();
	scrollSearch = createRef();

	getCountryCurrency = () => {

		let userCountryCode = localStorage.getItem('static-country-code');
		var currValue = ''

		CountryCode.map((data) => {
			if (data.countryCode === userCountryCode) {
				//   country = data;
				currValue = data.currencySymbol
			}
		});

		return currValue;
	}

	constructor(props) {
		super(props);
		this.state = {
			// device_category,bounce,user_type channel_id,landing_page
			datatabledropdown_options: [{ "value": "device_category", "label": "Device Type" }, { "value": "landing_page", "label": "Landing Page" }],
			trafficdropdown_options: [{ "value": "traffic_channels", "label": "Traffic Channels" }, { "value": "Category", "label": "Category" }],
			chartData: [{ "country": "Lithuania", "litres": 500, "subData": [{ "name": "A", "value": 200 }, { "name": "B", "value": 150 }, { "name": "C", "value": 100 }, { "name": "D", "value": 50 }] }, { "country": "Czech Republic", "litres": 300, "subData": [{ "name": "A", "value": 150 }, { "name": "B", "value": 100 }, { "name": "C", "value": 50 }] }, { "country": "Ireland", "litres": 200, "subData": [{ "name": "A", "value": 110 }, { "name": "B", "value": 60 }, { "name": "C", "value": 30 }] }, { "country": "Germany", "litres": 150, "subData": [{ "name": "A", "value": 80 }, { "name": "B", "value": 40 }, { "name": "C", "value": 30 }] }, { "country": "Australia", "litres": 140, "subData": [{ "name": "A", "value": 90 }, { "name": "B", "value": 40 }, { "name": "C", "value": 10 }] }, { "country": "Austria", "litres": 120, "subData": [{ "name": "A", "value": 60 }, { "name": "B", "value": 30 }, { "name": "C", "value": 30 }] }],
			dropdown_options: [{ "value": "All Visitor", "label": "All Visitors" }, { "value": "New Visitor", "label": "New Visitors" }, { "value": "Returning Visitor", "label": "Returning Visitors" }],
			mention_word_dropdown_option: [{ "value": "", "label": "All Events" }, { "value": "('add_to_cart',)", "label": "Add To Cart" }, { "value": "Add_to_Wishlist", "label": "Add to Wishlist" }, { "value": "LostFestive banner", "label": "LostFestive banner" }],
			mention_word_dropdown_option_s: [{ "value": "", "label": "All Events" }, { "value": "Add_to_cart", "label": "Add To Cart" }, { "value": "Add_to_Wishlist", "label": "Add to Wishlist" }, { "value": "LostFestive banner", "label": "LostFestive banner" }],
			trafficpievalue: '[{"name": "Social","value": 30},{"name": "Direct","value": 30},{ "name": "Website","value": 50},{ "name": "Email","value": 40},{ "name": "Organic","value": 60}]',
			linesparkgraph: [{ "date": "2012-07-27", "value": 13 }, { "date": "2012-07-28", "value": 10 }, { "date": "2012-07-29", "value": 15 }, { "date": "2012-07-30", "value": 15 }, { "date": "2012-07-31", "value": 15 }, { "date": "2012-08-01", "value": 15 }, { "date": "2012-08-02", "value": 15 }, { "date": "2012-08-03", "value": 19 }, { "date": "2012-08-04", "value": 16 }, { "date": "2012-08-05", "value": 15 }, { "date": "2012-08-06", "value": 19 }, { "date": "2012-08-07", "value": 17 }, { "date": "2012-08-08", "value": 18 }],
			bubblechart: [{ "date": "2015-01-01", "weekday": "Sun", "value": 2990 }, { "hour": "1pm", "weekday": "Sun", "value": 2990 }, { "hour": "2pm", "weekday": "Sun", "value": 1990 }, { "hour": "3pm", "weekday": "Sun", "value": 990 }, { "hour": "4pm", "weekday": "Sun", "value": 2000 }, { "hour": "5pm", "weekday": "Sun", "value": 7890 }, { "hour": "6pm", "weekday": "Sun", "value": 1290 }, { "hour": "7pm", "weekday": "Sun", "value": 1090 }, { "hour": "8pm", "weekday": "Sun", "value": 2990 }, { "hour": "9pm", "weekday": "Sun", "value": 2990 }, { "hour": "10pm", "weekday": "Sun", "value": 2990 }, { "hour": "11pm", "weekday": "Sun", "value": 2990 }, { "hour": "12pm", "weekday": "Sun", "value": 2990 }, { "hour": "1am", "weekday": "Sun", "value": 1890 }, { "hour": "2am", "weekday": "Sun", "value": 1990 }, { "hour": "3am", "weekday": "Sun", "value": 1000 }, { "hour": "4am", "weekday": "Sun", "value": 2100 }, { "hour": "5am", "weekday": "Sun", "value": 2990 }, { "hour": "6am", "weekday": "Sun", "value": 2100 }, { "hour": "7am", "weekday": "Sun", "value": 2990 }, { "hour": "8am", "weekday": "Sun", "value": 1200 }, { "hour": "9am", "weekday": "Sun", "value": 900 }, { "hour": "10am", "weekday": "Sun", "value": 2000 }, { "hour": "11am", "weekday": "Sun", "value": 1100 }, { "hour": "12am", "weekday": "Sun", "value": 2990 }, { "hour": "12pm", "weekday": "Mon", "value": 2990 }, { "hour": "1pm", "weekday": "Mon", "value": 2990 }, { "hour": "2pm", "weekday": "Mon", "value": 1990 }, { "hour": "3pm", "weekday": "Mon", "value": 990 }, { "hour": "4pm", "weekday": "Mon", "value": 2000 }, { "hour": "5pm", "weekday": "Mon", "value": 7890 }, { "hour": "6pm", "weekday": "Mon", "value": 1290 }, { "hour": "7pm", "weekday": "Mon", "value": 1090 }, { "hour": "8pm", "weekday": "Mon", "value": 2990 }, { "hour": "9pm", "weekday": "Mon", "value": 2990 }, { "hour": "10pm", "weekday": "Mon", "value": 2990 }, { "hour": "11pm", "weekday": "Mon", "value": 2990 }, { "hour": "12pm", "weekday": "Mon", "value": 2990 }, { "hour": "1am", "weekday": "Mon", "value": 1890 }, { "hour": "2am", "weekday": "Mon", "value": 1990 }, { "hour": "3am", "weekday": "Mon", "value": 1000 }, { "hour": "4am", "weekday": "Mon", "value": 2100 }, { "hour": "5am", "weekday": "Mon", "value": 2990 }, { "hour": "6am", "weekday": "Mon", "value": 2100 }, { "hour": "7am", "weekday": "Mon", "value": 2990 }, { "hour": "8am", "weekday": "Mon", "value": 1200 }, { "hour": "9am", "weekday": "Mon", "value": 900 }, { "hour": "10am", "weekday": "Mon", "value": 2000 }, { "hour": "11am", "weekday": "Mon", "value": 1100 }, { "hour": "12am", "weekday": "Mon", "value": 2990 }, { "hour": "12pm", "weekday": "Wed", "value": 2990 }, { "hour": "1pm", "weekday": "Wed", "value": 2990 }, { "hour": "2pm", "weekday": "Wed", "value": 1990 }, { "hour": "3pm", "weekday": "Wed", "value": 990 }, { "hour": "4pm", "weekday": "Wed", "value": 2000 }, { "hour": "5pm", "weekday": "Wed", "value": 7890 }, { "hour": "6pm", "weekday": "Wed", "value": 1290 }, { "hour": "7pm", "weekday": "Wed", "value": 1090 }, { "hour": "8pm", "weekday": "Wed", "value": 2990 }, { "hour": "9pm", "weekday": "Wed", "value": 2990 }, { "hour": "10pm", "weekday": "Wed", "value": 2990 }, { "hour": "11pm", "weekday": "Wed", "value": 2990 }, { "hour": "12pm", "weekday": "Wed", "value": 2990 }, { "hour": "1am", "weekday": "Wed", "value": 1890 }, { "hour": "2am", "weekday": "Wed", "value": 1990 }, { "hour": "3am", "weekday": "Wed", "value": 1000 }, { "hour": "4am", "weekday": "Wed", "value": 2100 }, { "hour": "5am", "weekday": "Wed", "value": 2990 }, { "hour": "6am", "weekday": "Wed", "value": 2100 }, { "hour": "7am", "weekday": "Wed", "value": 2990 }, { "hour": "8am", "weekday": "Wed", "value": 1200 }, { "hour": "9am", "weekday": "Wed", "value": 900 }, { "hour": "10am", "weekday": "Wed", "value": 2000 }, { "hour": "11am", "weekday": "Wed", "value": 1100 }, { "hour": "12am", "weekday": "Wed", "value": 2990 }, { "hour": "12pm", "weekday": "Wed", "value": 2990 }, { "hour": "1pm", "weekday": "Thu", "value": 2990 }, { "hour": "2pm", "weekday": "Thu", "value": 1990 }, { "hour": "3pm", "weekday": "Thu", "value": 990 }, { "hour": "4pm", "weekday": "Thu", "value": 2000 }, { "hour": "5pm", "weekday": "Thu", "value": 7890 }, { "hour": "6pm", "weekday": "Thu", "value": 1290 }, { "hour": "7pm", "weekday": "Thu", "value": 1090 }, { "hour": "8pm", "weekday": "Thu", "value": 2990 }, { "hour": "9pm", "weekday": "Thu", "value": 2990 }, { "hour": "10pm", "weekday": "Thu", "value": 2990 }, { "hour": "11pm", "weekday": "Thu", "value": 2990 }, { "hour": "12pm", "weekday": "Thu", "value": 2990 }, { "hour": "1am", "weekday": "Thu", "value": 1890 }, { "hour": "2am", "weekday": "Thu", "value": 1990 }, { "hour": "3am", "weekday": "Thu", "value": 1000 }, { "hour": "4am", "weekday": "Thu", "value": 2100 }, { "hour": "5am", "weekday": "Thu", "value": 2990 }, { "hour": "6am", "weekday": "Thu", "value": 2100 }, { "hour": "7am", "weekday": "Thu", "value": 2990 }, { "hour": "8am", "weekday": "Thu", "value": 1200 }, { "hour": "9am", "weekday": "Thu", "value": 900 }, { "hour": "10am", "weekday": "Thu", "value": 2000 }, { "hour": "11am", "weekday": "Thu", "value": 1100 }, { "hour": "12am", "weekday": "Thu", "value": 2990 }],
			pieofpiechartdata: [{ "country": "Custom1", "litres": 340, "subData": [{ "name": "Add To Cart", "value": 200 }, { "name": "Banner Click", "value": 150 }, { "name": "Internal Banner", "value": 100 }] }, { "country": "Custom", "litres": 500, "subData": [{ "name": "Add To Cart", "value": 200 }, { "name": "Banner Click", "value": 150 }, { "name": "Internal Banner", "value": 100 }] }, { "country": "Ecommerce", "litres": 300, "subData": [{ "name": "Add To Wishlist", "value": 150 }, { "name": "Banner Click", "value": 100 }, { "name": "Add To Cart", "value": 50 }] }],
			scroll: '',
			visibility: false,
			setShow: '',
			isActive: false,
			show: false,

			is_pie_data_loaded: false,
			is_engagement_metrices_loaded: false,
			is_engagement_lines_park_graph_loaded: false,
			is_event_matrices_loaded: false,
			is_event_spark_line_graph_loaded: false,
			is_search_matrices_data_loaded: false,
			is_search_lines_park_graph_data_loaded: false,
			is_bubble_graph_data_loaded: false,
			is_last_table_loaded: false,
			is_table_search_term_data_loaded: false,

			is_pie_table_data_loaded: false,
			is_event_pie_data_loaded: false,

			is_tranction_user_type_loaded: false,
			is_tranction_new_user_type_loaded: false,

			is_sessions_and_event_loaded: false,
			is_transction_and_search_loaded: false,
			is_sessions_and_search_loaded: false,
			is_tranction_and_event_loaded: false,



			is_pie_of_pie_data_loaded: false,

			pie_click_data: "",
			user_type: "",
			event_action: "",
			event_action_1: "",
			table_group: "",
			event_actions_list: "",
			session_actions_list: "",

			tranction_return_user_type_list: "",
			transction_and_user_type_graph_data: "",


			events: [{ name: "", field: "Channel Grouping", sortable: "false" }, { name: "", field: "Event Category", sortable: "false" }, { name: "", filed: "Event Action", sort: true }, { name: "", filed: "Event Label", sort: true }, { name: "Sessions", filed: "Sessions", sort: true }, { name: "", filed: "Total Events", sort: true }, { name: "", filed: "Unique Events", sort: true }, { name: "Events / Session with Event", filed: "", sort: true }, { name: "Transactions", filed: "Transactions", sort: true }, { name: "Revenue", filed: "Revenue", sort: true }, { name: "Avg Order Value", filed: "Avg Order Value", sort: true }],
			search: [{ name: "Channel Grouping", field: "Channel Grouping", sortable: "false" }, { name: "Event Category", field: "Event Category", sortable: "false" }, { name: "Event Action", filed: "Event Action", sort: true }, { name: "Event Label", filed: "Event Label", sort: true }, { name: "Sessions", filed: "Sessions", sort: true }, { name: "Total Events", filed: "Total Events", sort: true }, { name: "Unique Events", filed: "Unique Events", sort: true }, { name: "Events / Session with Event", filed: "Events / Session with Event", sort: true }, { name: "Transactions", filed: "Transactions", sort: true }, { name: "Revenue", filed: "Revenue", sort: true }, { name: "Avg Order Value", filed: "Avg Order Value", sort: true }],
			landingpage: [{ name: "Landing Page", field: "Landing Page", sortable: "false" }, { name: "Count", field: "Count", sortable: "false" }, { name: "Sales", filed: "Sales", sort: true }, { name: "Bills", filed: "Bills", sort: true }, { name: "ATS", filed: "ATS", sort: true }, { name: "NSU", filed: "NSU", sort: true }, { name: "Top Category", filed: "Top Category", sort: true }, { name: "Top Brand", filed: "Top Brand", sort: true }, { name: "Avg Time Between Purchases", filed: "Avg Time Between Purchases", sort: true }, { name: "Recency", filed: "Recency", sort: true }, { name: "Coupon Penetration", filed: "Coupon Penetration", sort: true }],
			comments: '',
			transactionAndUserType: [{ "date": "2021-08-13", "visits": 57, "views": 0 }, { "date": "2021-02-22", "visits": 538, "views": 0 }, { "date": "2021-02-12", "visits": 3973, "views": 0 }, { "date": "2021-06-03", "visits": 25, "views": 0 }, { "date": "2021-09-23", "visits": 63, "views": 0 }, { "date": "2021-06-21", "visits": 40, "views": 0 }, { "date": "2021-08-19", "visits": 77, "views": 0 }, { "date": "2021-04-27", "visits": 78, "views": 0 }, { "date": "2021-06-21", "visits": 67, "views": 0 }],
			searchTermData: [{ "date": "2015-01-01", "ay": 6.5, "aValue": 15 }, { "date": "2015-01-02", "ay": 12.3, "aValue": 8 }, { "date": "2015-01-03", "ay": 12.3, "aValue": 16 }, { "date": "2015-01-04", "ay": 2.8, "aValue": 9 }, { "date": "2015-01-05", "ay": 3.5, "aValue": 5 }, { "date": "2015-01-06", "ay": 5.1, "aValue": 10 }, { "date": "2015-01-07", "ay": 6.7, "aValue": 3 }, { "date": "2015-01-08", "ay": 8, "aValue": 5 }, { "date": "2015-01-09", "ay": 8.9, "aValue": 8 }, { "date": "2015-01-10", "ay": 9.7, "aValue": 15 }, { "date": "2015-01-11", "ay": 10.4, "aValue": 1 }, { "date": "2015-01-12", "ay": 1.7, "aValue": 12 }],
			// search_terms_bubble_graph: '',
			// table_data: '',
			// is_table_data_loaded: false,

			// device_category,bounce,user_type channel_id,landing_page
			table_header_landing_page: [
				{ 'name': 'Landing page', 'field': "page", 'sortable': true },
				{ 'name': 'Sessions', 'field': "sessions", 'sortable': true },
				{ 'name': 'Users', 'field': "users", 'sortable': true },
				{ 'name': 'New Users', 'field': "newusers", 'sortable': true },
				{ 'name': 'Returning Users', 'field': "returninguser", 'sortable': true },
				{ 'name': 'Bounce Rate (%)', 'field': "Bouncerate", 'sortable': true },
				{ 'name': '% Sessions With Search', 'field': "percentage_session_with_search", 'sortable': true },
				{ 'name': 'Avg Page Per Session', 'field': "avg_pages_per_session", 'sortable': true },
				{ 'name': 'Avg Sessions Duration', 'field': "avg_session_duration", 'sortable': true },
				{ 'name': 'Conversion Rate (%)', 'field': "conversionrate", 'sortable': true },
				{ 'name': `Sales(${this.getCountryCurrency()})`, 'field': "sales", 'sortable': true },
				{ 'name': 'Transactions', 'field': "transction", 'sortable': true },
				{ 'name': `Avg Order Value(${this.getCountryCurrency()})`, 'field': "avg_order_value", 'sortable': true },
				{ 'name': `Revenue Per Session(${this.getCountryCurrency()})`, 'field': "revenue_per_session", 'sortable': true },
			],
			table_header_device_category: [
				{ 'name': 'Device Category', 'field': "device_category", 'sortable': true },
				{ 'name': 'Sessions', 'field': "sessions", 'sortable': true },
				{ 'name': 'Users', 'field': "users", 'sortable': true },
				{ 'name': 'New Users', 'field': "newusers", 'sortable': true },
				{ 'name': 'Returning Users', 'field': "returninguser", 'sortable': true },
				{ 'name': 'Bounce Rate (%)', 'field': "Bouncerate", 'sortable': true },
				{ 'name': '% Sessions With Search', 'field': "percentage_session_with_search", 'sortable': true },
				{ 'name': 'Avg Page Per Session', 'field': "avg_pages_per_session", 'sortable': true },
				{ 'name': 'Avg Sessions Duration', 'field': "avg_session_duration", 'sortable': true },
				{ 'name': 'Conversion Rate (%)', 'field': "conversionrate", 'sortable': true },
				{ 'name': `Sales (${this.getCountryCurrency()})`, 'field': "sales", 'sortable': true },
				{ 'name': 'Transactions', 'field': "transction", 'sortable': true },
				{ 'name': `Avg Order Value(${this.getCountryCurrency()})`, 'field': "avg_order_value", 'sortable': true },
				{ 'name': `Revenue Per Session(${this.getCountryCurrency()})`, 'field': "revenue_per_session", 'sortable': true },
			],
			// table_header_user_type: [
			//     {'name':  'User Type','field': "usertype", 'sortable': true},
			//     {'name':  'Sessions','field': "sessions", 'sortable': true},
			//     {'name':  'Users','field': "users", 'sortable': true},
			//     {'name':  'New Users','field': "newusers", 'sortable': true},
			//     {'name':  'Returning Users','field': "returninguser", 'sortable': true},
			//     {'name':  'Bounce Rate','field': "Bouncerate", 'sortable': true},
			//     {'name':  '% Sessions With Search','field': "percentage_session_with_search", 'sortable': true},
			//     {'name':  'Avg Page Per Session','field': "avg_pages_per_session", 'sortable': true},
			//     {'name':  'Avg Sessions Duration', 'field': "avg_session_duration", 'sortable': true},
			//     {'name':  'Conversion Rate','field': "conversionrate", 'sortable': true},
			//     {'name':  'Sales','field': "sales", 'sortable': true},
			//     {'name':  'Transactions','field': "transction", 'sortable': true},
			//     {'name':  'Avg Order Value','field': "avg_order_value", 'sortable': true},
			//     {'name':  'Revenue Per Session','field': "revenue_per_session", 'sortable': true},
			// ],
			table_data: [
				{ page: '/', sessions: '11,395(31.44%)', newsessions: '78.31%', newuser: '8,923(36.07%)', Bouncerate: '3.13%', pagesessions: '6.76', duration: '00:02:09', transactions: '96(30.57%)', sales: '₹149,702.56(31.10%)', conversionrate: '0.84%', },
				{ page: '/men/jeans.html', sessions: '1,260(3.48%)', newsessions: '78.31%', newuser: '797(3.22%)', Bouncerate: '1.43%', pagesessions: '5.99', duration: '00:01:26', transactions: '12(3.82%)', sales: '₹27,552.61(5.72%)', conversionrate: '0.84%', },
				{ page: '/collections.html', sessions: '965(2.66%)', newsessions: '69.74%', newuser: '673(2.72%)', Bouncerate: '0.93%', pagesessions: '8.91', duration: '00:02:33', transactions: '15(4.78%)', sales: '₹33,501.28(6.96%)', conversionrate: '1.55%', },
				{ page: '/men/topwear.html?/utm_source=Discovery', sessions: '471(1.30%)', newsessions: '62.42%', newuser: '294(1.19%)', Bouncerate: '1.27%', pagesessions: '5.18', duration: '00:01:12', transactions: '1(0.32%)', sales: '₹1,079.10(0.22%)', conversionrate: '0.21%', },

			],
			table_events: [
				{ 'name': 'Channel Grouping', 'field': "channel_name", 'sortable': true },
				{ 'name': 'Event Category', 'field': "event_category", 'sortable': true },
				{ 'name': 'Event Action', 'field': "event_action", 'sortable': true },
				{ 'name': 'Event Label', 'field': "event_label", 'sortable': true },
				{ 'name': 'Date', 'field': "date", 'sortable': true },
				{ 'name': 'Total Events', 'field': "total_events", 'sortable': true },
				{ 'name': 'Unique Events', 'field': "unique_events", 'sortable': true },
				{ 'name': 'Events / Session with Event', 'field': "totalEvents", 'sortable': true },
				{ 'name': 'Transactions', 'field': "transactions", 'sortable': true },
				{ 'name': 'Revenue', 'field': "transaction_revenue", 'sortable': true },


			],
			table_events_data: [
				{ name: 'Social', category: 'Ecommerce', action: 'Add to Cart', eventlabel: '', sessions: '350', totalevents: '109', uniqueevents: '53', eventssessions: '', transactions: '47', revenue: '48964', avgordervalue: '1041.78' },
				{ name: 'Direct', category: 'Ecommerce', action: 'Add to wishlist', eventlabel: '', sessions: '400', totalevents: '195', uniqueevents: '103', eventssessions: '', transactions: '26', revenue: '20032', avgordervalue: '770.46' },
				{ name: 'Email', category: 'Custom', action: 'Banner Click', eventlabel: 'gdeo-7', sessions: '107', totalevents: '65', uniqueevents: '22', eventssessions: '', transactions: '10', revenue: '3615', avgordervalue: '361.78' },
				{ name: 'Other', category: 'Custom', action: 'Internal Banner', eventlabel: 'laptop_7_s', sessions: '152', totalevents: '65', uniqueevents: '15', eventssessions: '', transactions: '7', revenue: '36957', avgordervalue: '5279.57' },
			],
			table_search: [
				{ 'name': 'Search Term', 'field': "search_keyword", 'sortable': true },
				{ 'name': 'Site Search Category', 'field': "search_category", 'sortable': true },
				{ 'name': 'Start Page', 'field': "search_start_page", 'sortable': true },
				{ 'name': 'Results Pageviews', 'field': "search_result_views", 'sortable': true },
				{ 'name': 'Total Unique Searches', 'field': "search_uniques", 'sortable': true },
				{ 'name': 'Search Depth', 'field': "search_depth", 'sortable': true },
				{ 'name': 'Time After Search', 'field': "search_duration", 'sortable': true },
				{ 'name': 'Search Exits', 'field': "search_exits", 'sortable': true },
				{ 'name': 'Transactions', 'field': "transactions", 'sortable': true },
				{ 'name': 'Revenue', 'field': "transaction_revenue", 'sortable': true },
			],
			table_search_data: [
				{ searchterm: 'Shoes', category: 'Footwear', page: 'Home', pageviews: '', totalsearch: '6350', searchdepth: '7', timesearch: '310 seconds', exits: '', transactions: '23', revenue: '48964' },
				{ searchterm: 'Mobile phone', category: 'Elecetronics', page: 'Home', pageviews: '', totalsearch: '6350', searchdepth: '2', timesearch: '250 seconds', exits: '', transactions: '22', revenue: '35164' },
				{ searchterm: 'Laptop', category: 'Computers and Accessories', page: 'Home', pageviews: '', totalsearch: '6350', searchdepth: '3', timesearch: '110 seconds', exits: '', transactions: '13', revenue: '126494' },
				{ searchterm: 'Juicer', category: 'Kitchen Appliances', page: 'Login Page', pageviews: '', totalsearch: '6350', searchdepth: '6', timesearch: '36 seconds', exits: '', transactions: '15', revenue: '6946' }
			],

			is_scroll: false,

			first_start_date: props.start_date,
			first_end_date: props.end_date,
			second_start_date: props.previous_start_date,
			second_end_date: props.previous_end_date,
			isDatePickerOpen: false,

			trafficeChannel: '',
			formatMoney(n) {
				return (Math.round(n * 100) / 100).toLocaleString();
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props != nextProps) {
			this.setState({
				first_start_date: nextProps.start_date,
				first_end_date: nextProps.end_date,
				second_start_date: nextProps.previous_start_date,
				second_end_date: nextProps.previous_end_date,
			});
		}
	}

	componentDidMount() {
		this.state.is_pie_data_loaded = false;
		this.state.is_engagement_metrices_loaded = false;
		this.is_engagement_lines_park_graph_loaded = false;
		this.state.is_event_matrices_loaded = false;
		this.state.is_event_spark_line_graph_loaded = false;

		this.state.is_search_matrices_data_loaded = false;
		this.state.is_search_lines_park_graph_data_loaded = false;
		this.state.is_bubble_graph_data_loaded = false;
		this.state.is_last_table_loaded = false;
		this.state.is_table_search_term_data_loaded = false;

		this.state.is_pie_table_data_loaded = false;
		this.state.is_tranction_user_type_loaded = false;
		this.state.is_event_actions_list_loaded = false;
		this.state.is_session_actions_list_loaded = false;
		this.state.is_tranction_and_event_loaded = false;
		this.state.is_sessions_and_search_loaded = false;
		this.state.is_transction_and_search_loaded = false;
		this.state.is_pie_of_pie_data_loaded = false;
		this.state.is_event_pie_data_loaded = false;

		this.getTrafficByChannelPie();

		// all metrix
		this.getEngagementMatrices();
		this.getEngagementlinesparkgraph();

		this.getEventMatrices();
		this.getEventlinesparkgraph();

		this.getSearchMatrices();
		this.getSearchlinesparkgraph();


		// others graph
		this.getSearchTermsBubbleGraph();



		// all tables
		this.getEngagementTable();
		this.getSearchTermTable();
		this.getPieOfPieTable();

		// all multilines chart
		this.getTransactions_And_User_Type();


		this.getEventActionsForTransctionAndEvent();
		this.getEventActionsForSessionAndEvent();

		this.getTransactionsAndEvent();
		this.getSessionAndSearch();
		this.getTransctionAndSearch();
		this.getSessionAndEvent();

		this.getEventBreakdownPieOfPie();

		this.forceUpdate();
		window.addEventListener("scroll", this.handleScroll);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.start_date !== this.props.start_date ||
			prevProps.end_date !== this.props.end_date ||
			prevProps.previous_start_date !== this.props.previous_start_date ||
			prevProps.previous_end_date !== this.props.previous_end_date
		) {
			this.state.is_pie_data_loaded = false;
			this.state.is_engagement_metrices_loaded = false;
			this.is_engagement_lines_park_graph_loaded = false;
			this.state.is_event_matrices_loaded = false;
			this.state.is_event_spark_line_graph_loaded = false;

			this.state.is_search_matrices_data_loaded = false;
			this.state.is_search_lines_park_graph_data_loaded = false;
			this.state.is_bubble_graph_data_loaded = false;
			this.state.is_last_table_loaded = false;
			this.state.is_table_search_term_data_loaded = false;

			this.state.is_pie_table_data_loaded = false;
			this.state.is_tranction_user_type_loaded = false;
			this.state.is_event_actions_list_loaded = false;
			this.state.is_session_actions_list_loaded = false;
			this.state.is_tranction_and_event_loaded = false;
			this.state.is_sessions_and_search_loaded = false;
			this.state.is_transction_and_search_loaded = false;
			this.state.is_pie_of_pie_data_loaded = false;
			this.state.is_event_pie_data_loaded = false;

			this.getTrafficByChannelPie();

			// all metrix
			this.getEngagementMatrices();
			this.getEngagementlinesparkgraph();

			this.getEventMatrices();
			this.getEventlinesparkgraph();

			this.getSearchMatrices();
			this.getSearchlinesparkgraph();

			// others graph
			this.getSearchTermsBubbleGraph();

			// all tables
			this.getEngagementTable();
			this.getSearchTermTable();
			this.getPieOfPieTable();

			// all multilines chart
			this.getTransactions_And_User_Type();

			this.getEventActionsForTransctionAndEvent();
			this.getEventActionsForSessionAndEvent();

			this.getTransactionsAndEvent();
			this.getSessionAndSearch();
			this.getTransctionAndSearch();
			this.getSessionAndEvent();

			this.getEventBreakdownPieOfPie();
		}
	}

	handlePieclick = (childData) => {
		if (this.state.pie_click_data === childData) {
			this.state.pie_click_data = ""
		} else {
			this.state.pie_click_data = childData;
		}
		this.state.trafficeChannel = childData;

		this.setState({
			is_engagement_metrices_loaded: false,
			is_engagement_lines_park_graph_loaded: false,

			is_event_matrices_loaded: false,
			is_event_spark_line_graph_loaded: false,

			is_search_matrices_data_loaded: false,
			is_search_lines_park_graph_data_loaded: false,

			is_last_table_loaded: false,
			is_table_search_term_data_loaded: false,


			is_transction_and_search_loaded: false,
			is_sessions_and_search_loaded: false,
			is_pie_table_data_loaded: false,
			is_event_pie_data_loaded: false,

			is_tranction_and_event_loaded: false,
			is_sessions_and_event_loaded: false,

			is_tranction_new_user_type_loaded: false,
			is_tranction_user_type_loaded: false,

			is_pie_of_pie_data_loaded: false,

			is_bubble_graph_data_loaded: false,

			is_session_actions_list_loaded: false,
			is_event_actions_list_loaded: false,


		});
		// all matrix
		this.getEngagementMatrices();
		this.getEngagementlinesparkgraph();

		this.getEventMatrices();
		this.getEventlinesparkgraph();

		this.getSearchMatrices();
		this.getSearchlinesparkgraph();




		// Multi lines chart
		// this.getTransactions_And_User_Type();
		// this.getTransactions_And_New_User();

		this.getTransactionsAndEvent();
		this.getSessionAndSearch();
		this.getTransctionAndSearch();
		this.getSessionAndEvent();


		// tables
		this.getEngagementTable();
		this.getSearchTermTable();
		this.getPieOfPieTable();
		this.getEventActionsForTransctionAndEvent();
		this.getEventActionsForSessionAndEvent();

		this.getEventBreakdownPieOfPie();

		this.getSearchTermsBubbleGraph();

		if (this.state.user_type == 'New Visitor' || this.state.user_type == 'Returning Visitor') {
			this.getTransactions_And_New_User();
		} else {
			this.getTransactions_And_User_Type();
		}

	}

	handleCallback = (childData) => {
		this.state.user_type = childData;
		this.setState({
			is_tranction_user_type_loaded: false,
			is_tranction_new_user_type_loaded: false,
			tranction_user_type_list: []

		})



		if (this.state.user_type == 'New Visitor' || this.state.user_type == 'Returning Visitor') {

			// this.is_tranction_user_type_loaded = false;
			this.getTransactions_And_New_User();

		} else {

			this.getTransactions_And_User_Type();

		}


		// this.setState({ daily_metrics_name: childData, is_daily_data_loaded: false });
	}

	handleMentionWordCallback = (childData) => {

		this.state.event_action = childData;
		// this.state.is_sessions_and_event_loaded=false
		this.setState({ is_tranction_and_event_loaded: false })
		this.getTransactionsAndEvent();
		// this.setState({ mention_sentiment: childData, is_mention_word_data_loaded: false });
	}

	handleSessionWordCallback = (childData) => {

		this.state.event_action_1 = childData;

		this.setState({ is_sessions_and_event_loaded: false })
		this.getSessionAndEvent();

	}

	handletrafficCallback = (childData) => {
		this.setState({ trafficdropdown_options: childData, is_traffic_word_data_loaded: false });
	}

	handledatatableCallback = (childData) => {
		this.state.table_group = childData;
		this.setState({ is_last_table_loaded: false })
		this.getEngagementTable();

		// this.setState({ datatabledropdown_options: childData, is_datatable_word_data_loaded: false });

	}

	eventShow = () => {
		this.setState({
			isActive: true
		});
		// this.scrollDiv.current.scrollIntoView({ behavior: "smooth" });
	}


	eventHide = () => {
		this.setState({
			isActive: false
		})
	}

	searchShow = () => {
		this.setState({
			show: true
		});
		this.scrollSearch.current.scrollIntoView({ behavior: "smooth" });
	}

	searchHide = () => {
		this.setState({
			show: false
		})
	}

	loadEngagementData() {
	}

	getTrafficByChannelPie() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		const url = API_URL + "ecom/engagement-traffic-by-channel-pie/"

		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date,
			//"&social_platform=" + 'FACEBOOK',

			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let pie_list = result['engagement_summary_pie_list']
				let data_list = [];
				pie_list.map((info, index) => {
					try {
						let a = {
							"name": info['channel_name'],
							"value": info['total_session']

						}
						data_list.push(a);

					} catch {

					}

				})
				this.setState({
					is_pie_data_loaded: true,
					trafficpievalue: data_list

				});
			},
				(error) => {
				}
			)

	}

	// Event Breakdown
	getEventBreakdownPieOfPie() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;
		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/event-break-down-pie-of-pie/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let lis_of_top_bottom_parent = []
				for (var i in result['event_category_list']) {

					var sub_data = [];
					for (var k in result['event_break_down_pie_of_pie_list']) {

						if (result['event_break_down_pie_of_pie_list'][k]['event_category'] == result['event_category_list'][i]['event_category']) {
							// ((info['event_action'].replace('(','')).replace(')','')).replace(',','').replace("'","").replace("'",""),
							var sub_info = {
								"name": ((result['event_break_down_pie_of_pie_list'][k]['event_action'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", "").replace('_', ' ').replace('_', ' '),
								"value": result['event_break_down_pie_of_pie_list'][k]['total_events']
							};
							sub_data.push(sub_info);
						}

					}


					var info = {
						"country": ((result['event_category_list'][i]['event_category'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", "").replace('_', ' ').replace('_', ' '),
						"litres": result['event_category_list'][i]['total_events'],
						"subData": sub_data
					};

					lis_of_top_bottom_parent.push(info);
				}

				this.setState({
					is_pie_of_pie_data_loaded: true,
					pieofpiechartdata: lis_of_top_bottom_parent,

				});

			},
				(error) => { }
			)



	}

	getTransactions_And_User_Type() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/transction-usertype-multiline/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&campaign_name=" + '' +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let video_list = result['tranction_user_type_list'];
				let data_list = [];

				video_list.map((info, index) => {
					try {

						let a = {
							"date": info['date'],
							"visits": info['transaction_sum'],
							// "views":info['transactions'],
						}

						data_list.push(a);
					} catch {

					}
				});


				this.setState({ is_tranction_user_type_loaded: true, tranction_user_type_list: data_list });
			},
				(error) => {

				}
			)

	}

	getTransactions_And_New_User() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;
		let user_type = this.state.user_type;

		const url = API_URL + "ecom/transction-usertype-multiline/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&campaign_name=" + '' +
				"&pie_click_data=" + pie_click_data +
				"&user_type=" + user_type,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let video_list = result['tranction_user_type_list'];
				let data_list = [];

				video_list.map((info, index) => {

					try {


						let a = {
							"date": info['date'],
							"visits": info['transaction_sum'],
							"views": info['transactions'],
						}
						data_list.push(a);





					} catch {
						//   date: newDate,
					}
				});


				this.setState({ is_tranction_new_user_type_loaded: true, tranction_user_type_list: data_list });
			},
				(error) => {
				}
			)

	}

	getEventActionsForTransctionAndEvent() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-event-actions/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&social_platform=" + 'FACEBOOK' +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let event_actions_list = result['event_actions_list'];

				let data_list = [];
				event_actions_list.map((info, index) => {
					try {
						let a = {
							"value": info['event_action'],
							"label": ((info['event_action'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", "").replace("_", " ").replace("_", " ").replace("_", " "),
						}
						data_list.push(a);


					} catch {
						//   date: newDate,
					}
				});


				this.setState({ is_event_actions_list_loaded: true, event_actions_list: data_list });
			},
				(error) => {
				}
			)

	}

	getEventActionsForSessionAndEvent() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-event-actions/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&social_platform=" + 'FACEBOOK' +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let event_actions_list_2 = result['event_actions_list'];

				let data_list_1 = [];
				event_actions_list_2.map((info, index) => {
					let label = ((info['event_action'].replace('(', '')).replace(')', '')).replace(',', '');
					//((info['event_action'].replace('(','')).replace(')','')).replace(',',''),
					try {
						let a = {
							"value": info['event_action'],
							"label": ((info['event_action'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", "").replace("_", " ").replace("_", " ").replace("_", " "),
						}
						data_list_1.push(a);


					} catch {
						//   date: newDate,
					}
				});

				this.setState({ is_session_actions_list_loaded: true, session_actions_list: data_list_1 });
			},
				(error) => {
				}
			)

	}

	getTransactionsAndEvent() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;
		let event_action = this.state.event_action

		const url = API_URL + "ecom/engagement-transction-and-event-multiline-charts/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data +
				"&event_action=" + event_action,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let video_list = result['tranction_and_event_list'];

				let data_list = [];
				video_list.map((info, index) => {
					try {

						let a = {
							"date": info['date'],
							"visits": info['total_events'],
							"views": info['total_orders'],
						}
						data_list.push(a);
					} catch {
						//   date: newDate,
					}
				});

				this.setState({ is_tranction_and_event_loaded: true, tranction_and_event_graph: data_list });
			},
				(error) => {
				}
			)

	}

	getSessionAndSearch() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-session-and-search-multiline-charts/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&social_platform=" + 'FACEBOOK' +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let video_list = result['sessions_and_search_list'];

				let data_list = [];
				video_list.map((info, index) => {
					try {

						let a = {
							"date": info['date'],
							"visits": info['search_uniques'],
							"views": info['total_session'],
						}
						data_list.push(a);
					} catch {
						//   date: newDate,
					}
				});

				this.setState({ is_sessions_and_search_loaded: true, sessions_and_search_graph: data_list });
			},
				(error) => {
				}
			)

	}

	getTransctionAndSearch() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-transction-and-search-multiline-charts/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&social_platform=" + 'FACEBOOK' +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let video_list = result['transction_and_search_list'];

				let data_list = [];
				video_list.map((info, index) => {
					try {

						let a = {
							"date": info['date'],
							"visits": info['search_uniques'],
							"views": info['total_orders'],
						}
						data_list.push(a);
					} catch {
						//   date: newDate,
					}
				});

				this.setState({ is_transction_and_search_loaded: true, transction_and_search_graph: data_list });
			},
				(error) => {
				}
			)

	}

	getSessionAndEvent() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;
		let event_action_1 = this.state.event_action_1;

		const url = API_URL + "ecom/engagement-session-and-event-multiline-charts/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data +
				"&event_action_1=" + event_action_1,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let video_list = result['sessions_and_event_list'];

				let data_list = [];
				video_list.map((info, index) => {
					try {

						let a = {
							"date": info['date'],
							"visits": info['total_events'],
							"views": info['total_session'],
						}
						data_list.push(a);
					} catch {
						//   date: newDate,
					}
				});

				this.setState({ is_sessions_and_event_loaded: true, sessions_and_event_graph: data_list });
			},
				(error) => {
				}
			)

	}

	getEngagementMatrices() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-matrices/"

		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&social_platform=" + 'FACEBOOK' +
				'&pie_click_data=' + pie_click_data,

			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {

				let current_session = result['current_ecom_metrices_list'][0]['session']
				let last_session = result['last_ecom_metrices_list'][0]['session']
				let current_users = result['current_ecom_metrices_list'][0]['users']
				let last_users = result['last_ecom_metrices_list'][0]['users']
				let current_bounce = result['current_ecom_metrices_list'][0]['bounce']
				let last_bounce = result['last_ecom_metrices_list'][0]['bounce']
				let current_session_duration_in_seconds = result['current_ecom_metrices_list'][0]['session_duration_in_seconds']
				let last_session_duration_in_seconds = result['last_ecom_metrices_list'][0]['session_duration_in_seconds']
				let current_session_page_views = result['current_ecom_metrices_list'][0]['page_views']
				let last_session_page_views = result['last_ecom_metrices_list'][0]['page_views']

				let current_sessions_per_user;
				let current_bounce_rate;
				let current_average_session_duration;
				let current_average_pages_per_session;

				let last_sessions_per_user;
				let last_bounce_rate;
				let last_average_session_duration;
				let last_average_pages_per_session;

				current_sessions_per_user = (current_session / current_users);
				last_sessions_per_user = (last_session / last_users);
				// (Bounces/Sessions)*100
				current_bounce_rate = (current_bounce / current_session) * 100;
				last_bounce_rate = (last_bounce / last_session) * 100;
				// Session Duration/Sessions
				current_average_session_duration = (current_session_duration_in_seconds / current_session);
				last_average_session_duration = (last_session_duration_in_seconds / last_session);
				// Pageviews/Sessions
				current_average_pages_per_session = (current_session_page_views / current_session);
				last_average_pages_per_session = (last_session_page_views / last_session);




				this.setState({
					is_engagement_metrices_loaded: true,
					current_session: current_session,
					last_session: last_session,
					current_sessions_per_user: current_sessions_per_user,
					last_sessions_per_user: last_sessions_per_user,
					current_bounce_rate: current_bounce_rate,
					last_bounce_rate: last_bounce_rate,
					current_average_session_duration: current_average_session_duration,
					last_average_session_duration: last_average_session_duration,
					current_average_pages_per_session: current_average_pages_per_session,
					last_average_pages_per_session: last_average_pages_per_session,

				});
			},
				(error) => {
				}
			)

	}

	getEngagementlinesparkgraph() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-matrices/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&social_platform=" + 'FACEBOOK' +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {

				let sparkline_list = result['ecom_metrices_sparkline_list']

				let sessions_spark_list = [];
				let sessions_per_user_spark_list = [];
				let bounce_rate_spark_list = [];
				let average_session_duration_spark_list = [];
				let average_pages_per_session_spark_list = [];

				// date
				// session
				// users
				// bounce
				// session_duration_in_seconds
				// page_views


				// Sessions per User   Sessions/Users
				// Bounce rate    (Bounces/Sessions)*100
				// Average Session Duration Session Duration/Sessions
				// Average Pages per Session     Pageviews/Sessions

				sparkline_list.map((info, index) => {
					try {
						let a = {
							"date": info['date'],
							"value": info['session']
						}
						sessions_spark_list.push(a);

						let b = {
							"date": info['date'],
							"value": (info['session'] / info['users']).toFixed(2)
						}
						sessions_per_user_spark_list.push(b);

						let c = {
							"date": info['date'],
							"value": ((info['bounce'] / info['session']) * 100).toFixed(2)
						}
						bounce_rate_spark_list.push(c);

						let d = {
							"date": info['date'],
							"value": (info['session_duration_in_seconds'] / info['session']).toFixed(2)
						}
						average_session_duration_spark_list.push(d);

						let f = {
							"date": info['date'],
							"value": (info['page_views'] / info['session']).toFixed(2)
						}
						average_pages_per_session_spark_list.push(f);

					} catch (e) {

					}

				})

				this.setState({
					is_engagement_lines_park_graph_loaded: true,
					sessions_spark_graph: sessions_spark_list,
					sessions_per_user_spark_graph: sessions_per_user_spark_list,
					bounce_rate_spark_graph: bounce_rate_spark_list,
					average_session_duration_spark_graph: average_session_duration_spark_list,
					average_pages_per_session_spark_graph: average_pages_per_session_spark_list,


				});
			},
				(error) => {
				}
			)


	}

	getEventMatrices() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-event-matrices/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data,

			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				// ga:sessionsWithEvent
				// ga:totalEvents
				// ga:uniqueEvents
				let current_sessions_with_event = result['current_ecom_metrices_list'][0]['sessions_with_event'];
				let current_total_events = result['current_ecom_metrices_list'][0]['total_events'];
				let current_unique_events = result['current_ecom_metrices_list'][0]['unique_events']

				let last_sessions_with_event = result['last_ecom_metrices_list'][0]['sessions_with_event'];
				let last_total_events = result['last_ecom_metrices_list'][0]['total_events'];
				let last_unique_events = result['last_ecom_metrices_list'][0]['unique_events']

				this.setState({
					is_event_matrices_loaded: true,
					current_sessions_with_event: current_sessions_with_event,
					current_total_events: current_total_events,
					current_unique_events: current_unique_events,

					last_sessions_with_event: last_sessions_with_event,
					last_total_events: last_total_events,
					last_unique_events: last_unique_events,
				});
			},
				(error) => {
				}
			)

	}

	getEventlinesparkgraph() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-event-matrices/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let sparkline_list = result['ecom_metrices_sparkline_list']
				let total_events_list = [];
				let unique_events_list = [];
				let sessions_with_event_list = [];

				sparkline_list.map((info, index) => {
					try {
						let a = {
							"date": info['date'],
							"value": info['total_events']
						}
						total_events_list.push(a);

						let b = {
							"date": info['date'],
							"value": info['unique_events']
						}
						unique_events_list.push(b);

						let c = {
							"date": info['date'],
							"value": info['sessions_with_event']
						}
						sessions_with_event_list.push(c);

					} catch (e) { }
				})

				this.setState({
					is_event_spark_line_graph_loaded: true,
					total_events_graph: total_events_list,
					unique_events_graph: unique_events_list,
					sessions_with_event_graph: sessions_with_event_list,
				});
			},
				(error) => {
				}
			)

	}

	getSearchMatrices() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-search-matrices/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&social_platform=" + 'FACEBOOK' +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				// search_sessions
				// search_uniques
				// search_depth
				// search_duration
				let current_search_sessions = result['current_ecom_metrices_list'][0]['search_sessions'];
				let current_search_uniques = result['current_ecom_metrices_list'][0]['search_uniques'];
				let current_search_depth = result['current_ecom_metrices_list'][0]['search_depth'];
				let current_search_duration = result['current_ecom_metrices_list'][0]['search_duration'];

				let last_search_sessions = result['last_ecom_metrices_list'][0]['search_sessions'];
				let last_search_uniques = result['last_ecom_metrices_list'][0]['search_uniques'];
				let last_search_depth = result['last_ecom_metrices_list'][0]['search_depth'];
				let last_search_duration = result['last_ecom_metrices_list'][0]['search_duration'];

				// % SESSIONS WITH SEARCH
				// TOTAL UNIQUE SEARCHES
				// AVERAGE SEARCH DEPTH
				// AVERAGE TIME AFTER SEARCH

				// (ga:searchSessions/ga:sessions (from summary calculation)) * 100
				// ga:searchUniques
				// "ga:searchDepth/ga:searchSessions
				// ga:searchDuration/ga:searchSessions

				// let current_session_with_search = (current_search_sessions/current_session)*100;
				let current_avg_search_depth = (current_search_depth / current_search_uniques)
				let last_avg_search_depth = (last_search_depth / last_search_uniques)

				let current_avg_time_after_search = (current_search_duration / current_search_uniques)
				let last_avg_time_after_search = (last_search_duration / last_search_uniques)



				this.setState({
					is_search_matrices_data_loaded: true,

					current_search_uniques: isFinite(current_search_uniques) ? current_search_uniques : 0,
					last_search_uniques: isFinite(last_search_uniques) ? last_search_uniques : 0,

					current_avg_search_depth: isFinite(current_avg_search_depth) ? current_avg_search_depth : 0,
					last_avg_search_depth: isFinite(last_avg_search_depth) ? last_avg_search_depth : 0,

					current_avg_time_after_search: isFinite(current_avg_time_after_search) ? current_avg_time_after_search : 0,
					last_avg_time_after_search: isFinite(last_avg_time_after_search) ? last_avg_time_after_search : 0,


				});
			},
				(error) => {
				}
			)

	}

	getSearchlinesparkgraph() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/engagement-search-matrices/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&social_platform=" + 'FACEBOOK' +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {

				let sparkline_list = result['ecom_metrices_sparkline_list']
				// % SESSIONS WITH SEARCH
				// TOTAL UNIQUE SEARCHES
				// AVERAGE SEARCH DEPTH
				// AVERAGE TIME AFTER SEARCH

				// (ga:searchSessions/ga:sessions (from summary calculation)) * 100
				// ga:searchUniques
				// "ga:searchDepth/ga:searchSessions
				// ga:searchDuration/ga:searchSessions

				let session_with_search_list = [];
				let total_unique_search_list = [];
				let avg_search_depth_list = [];
				let avg_time_after_search_list = [];
				sparkline_list.map((info, index) => {
					try {
						let a = {
							"date": info['date'],
							"value": (info['search_uniques'])
						}
						total_unique_search_list.push(a);

						let b = {
							"date": info['date'],
							"value": isFinite(info['search_depth'] / info['search_uniques']) ? (info['search_depth'] / info['search_uniques']) : 0
						}
						avg_search_depth_list.push(b);
						let c = {
							"date": info['date'],
							"value": isFinite(info['search_duration'] / info['search_uniques']) ? (info['search_duration'] / info['search_uniques']) : 0
						}
						avg_time_after_search_list.push(c);


					} catch (e) { }
				})

				this.setState({
					is_search_lines_park_graph_data_loaded: true,
					total_unique_search_graph: total_unique_search_list,
					avg_search_depth_graph: avg_search_depth_list,
					avg_time_after_search_graph: avg_time_after_search_list,


				});
			},
				(error) => {
				}
			)

	}

	// event-break-down-pie-of-pie
	getEventBreakDownPieOfPie() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;
		let pie_click_data = this.state.pie_click_data;
		const url = API_URL + "ecom/event-break-down-pie-of-pie/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data,

			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let lis_of_top_bottom_parent = []
				for (var i in result['event_category_list']) {

					var sub_data = [];
					for (var k in result['event_break_down_pie_of_pie_list']) {

						if (result['event_break_down_pie_of_pie_list'][k]['event_category'] == result['event_category_list'][i]['event_category']) {
							// ((info['event_action'].replace('(','')).replace(')','')).replace(',','').replace("'","").replace("'",""),
							var sub_info = {
								"name": ((result['event_break_down_pie_of_pie_list'][k]['event_action'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", "").replace('_', ' ').replace('_', ' '),
								"value": result['event_break_down_pie_of_pie_list'][k]['total_events']
							};
							sub_data.push(sub_info);
						}
					}


					var info = {
						"country": ((result['event_category_list'][i]['event_category'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", "").replace('_', ' ').replace('_', ' '),
						"litres": result['event_category_list'][i]['total_events'],
						"subData": sub_data
					};

					lis_of_top_bottom_parent.push(info);
				}

				this.setState({
					is_pie_of_pie_data_loaded: true,
					pieofpiechartdata: lis_of_top_bottom_parent,

				});

			},
				(error) => {
				}
			)

	}

	// search-terms-buuble-graph
	// search-terms-buuble-graph
	getSearchTermsBubbleGraph() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/search-terms-buuble-graph/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let pie_list = result['search_terms_bubble_graph_list']
				let data_list = [];
				pie_list.map((info, index) => {
					try {
						let a = {
							"date": info['transaction_revenue'] / info['transactions'],
							"ay": info['transactions'],
							"aValue": info['search_uniques'],
							"bubbleLabelText": info['search_keyword'],

						}
						data_list.push(a);

					} catch {

					}

				})
				this.setState({
					is_bubble_graph_data_loaded: true,
					search_terms_bubble_graph: data_list



				});
			},
				(error) => {
				}
			)

	}

	getEngagementTable() {

		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;
		let table_group = this.state.table_group;

		const url = API_URL + "ecom/engagement-table/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data +
				"&table_group=" + table_group,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let engagement_table_list = result['engagement_table_list']
				let data_list = [];
				engagement_table_list.map((info, index) => {

					if (this.state.table_group === 'landing_page') {
						try {
							let a = {
								"page": (info['landing_page'] ? info['landing_page'] : 0),
								"sessions": (info['session'] ? info['session'] : 0),
								"users": (info['users'] ? info['users'] : 0),
								"newusers": (info['newuser'] ? info['newuser'] : 0),
								"returninguser": (info['returninguser'] ? info['returninguser'] : 0),
								"Bouncerate": ((info['bounce'] / info['session']) ? Math.abs((info['bounce'] / info['session']) * 100).toFixed(2) : 0),
								"percentage_session_with_search": ((info['search_sessions'] / info['session']) ? Math.abs(info['search_sessions'] / info['session']).toFixed(2) : 0),
								"avg_pages_per_session": ((info['page_views'] / info['page_views']) ? Math.abs((info['page_views'] / info['page_views'])).toFixed(2) : 0),
								"avg_session_duration": ((info['session_duration_in_seconds'] / info['session']) ? Math.abs(info['session_duration_in_seconds'] / info['session']).toFixed(2) : 0),
								"conversionrate": ((info['transactions'] / info['session']) * 100) ? Math.abs(((info['transactions'] / info['session']) * 100)).toFixed(2) : 0,
								"sales": (info['transaction_revenue'] ? (info['transaction_revenue']).toFixed(2) : 0),
								"transction": (info['transactions'] ? info['transactions'] : 0),
								"avg_order_value": ((info['transaction_revenue'] / info['transactions']) ? Math.abs(info['transaction_revenue'] / info['transactions']).toFixed(2) : 0),
								"revenue_per_session": ((info['transaction_revenue'] / info['session']) ? Math.abs(info['transaction_revenue'] / info['session']).toFixed(2) : 0),

							}

							data_list.push(a);

						} catch {

						}

					}
					else {
						try {
							let a = {
								"device_category": (info['device_category'] ? info['device_category'] : 0),
								"sessions": (info['session'] ? info['session'] : 0),
								"users": (info['users'] ? info['users'] : 0),
								"newusers": (info['newuser'] ? info['newuser'] : 0),
								"returninguser": (info['returninguser'] ? info['returninguser'] : 0),
								"Bouncerate": ((info['bounce'] / info['session']) ? Math.abs((info['bounce'] / info['session']) * 100).toFixed(2) : 0),
								"percentage_session_with_search": ((info['search_sessions'] / info['session']) ? Math.abs(info['search_sessions'] / info['session']).toFixed(2) : 0),
								"avg_pages_per_session": ((info['page_views'] / info['session']) ? Math.abs((info['page_views'] / info['session'])).toFixed(2) : 0),
								"avg_session_duration": ((info['session_duration_in_seconds'] / info['session']) ? Math.abs(info['session_duration_in_seconds'] / info['session']).toFixed(2) : 0),
								"conversionrate": ((info['transactions'] / info['session']) * 100) ? Math.abs(((info['transactions'] / info['session']) * 100)).toFixed(2) : 0,
								"sales": this.state.formatMoney((info['transaction_revenue']) ? (info['transaction_revenue']).toFixed(2) : 0),
								"transction": (info['transactions'] ? info['transactions'] : 0),
								"avg_order_value": ((info['transaction_revenue'] / info['transactions']) ? Math.abs(info['transaction_revenue'] / info['transactions']).toFixed(2) : 0),
								"revenue_per_session": ((info['transaction_revenue'] / info['session']) ? Math.abs(info['transaction_revenue'] / info['session']).toFixed(2) : 0),

							}

							data_list.push(a);

						} catch {

						}

					}


				})
				this.setState({
					is_last_table_loaded: true,
					last_table_values: data_list

				});
			},
				(error) => {
				}
			)

	}

	getSearchTermTable() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/search-term-table/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let engagement_table_list = result['search_terms_table_list']
				let data_list = [];
				engagement_table_list.map((info, index) => {
					// ((info['event_action'].replace('(','')).replace(')','')).replace(',','').replace("'","").replace("'",""),
					try {
						let a = {
							"search_keyword": ((info['search_keyword'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", ""),
							"search_category": ((((info['search_category'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", "").replace('(', '')).replace(')', '')),
							"search_start_page": ((info['search_start_page'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", ""),
							"search_result_views": info['search_result_views'],
							"search_uniques": info['search_uniques'],
							"search_depth": (info['search_depth'] / info['search_uniques']) ? info['search_depth'] / info['search_uniques'] : 0,
							"search_duration": (info['search_duration'] / info['search_uniques']) ? info['search_duration'] / info['search_uniques'] : 0,
							"search_exits": info['search_exits'],
							"transactions": info['transactions'],
							"transaction_revenue": info['transaction_revenue'],

						}
						data_list.push(a);

					} catch {

					}

				})
				this.setState({
					// table_search_data
					is_table_search_term_data_loaded: true,
					table_search_term_data: data_list

				});

			},
				(error) => {
				}
			)

	}

	getPieOfPieTable() {
		let start_date = this.state.first_start_date;
		let end_date = this.state.first_end_date;
		let previous_start_date = this.state.second_start_date;
		let previous_end_date = this.state.second_end_date;

		let pie_click_data = this.state.pie_click_data;

		const url = API_URL + "ecom/pie-of-pie-table/"
		fetch(url, {
			method: 'POST',
			body: "start_date=" + start_date +
				"&end_date=" + end_date +
				"&last_start_date=" + previous_start_date +
				"&last_end_date=" + previous_end_date +
				"&pie_click_data=" + pie_click_data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Authorization': ' Bearer ' + localStorage.getItem("token")
			},
		}

		)
			.then(res => res.json())
			.then((result) => {
				let engagement_table_list = result['pie_of_pie_table_list']
				let data_list = [];
				engagement_table_list.map((info, index) => {

					try {
						let a = {
							"channel_name": ((info['channel_name'].replace('(', '')).replace(')', '')).replace(',', ''),
							"event_category": ((info['event_category'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", ""),
							"event_action": ((info['event_action'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", "").replace('_', ' ').replace('_', ' '),
							"event_label": ((info['event_label'].replace('(', '')).replace(')', '')).replace(',', '').replace("'", "").replace("'", ""),
							"date": info['date'],
							"total_events": info['total_events'],
							"unique_events": info['unique_events'],
							"totalEvents": (info['totalEvents'] / info['sessions_with_event']) ? info['totalEvents'] / info['sessions_with_event'] : 0,
							"transactions": info['transactions'],
							"transaction_revenue": info['transaction_revenue'],

						}
						data_list.push(a);

					} catch {

					}

				})
				this.setState({
					is_pie_table_data_loaded: true,
					table_events_data: data_list

				});
			},
				(error) => {
				}
			)

	}

	datepickerHandleCallback = (childData) => {

		this.state.first_start_date = childData[0];
		this.state.first_end_date = childData[1];
		this.state.second_start_date = childData[2];
		this.state.second_end_date = childData[3];

		this.state.is_pie_data_loaded = false;
		this.state.is_engagement_metrices_loaded = false;
		this.is_engagement_lines_park_graph_loaded = false;
		this.state.is_event_matrices_loaded = false;
		this.state.is_event_spark_line_graph_loaded = false;

		this.state.is_search_matrices_data_loaded = false;
		this.state.is_search_lines_park_graph_data_loaded = false;
		this.state.is_bubble_graph_data_loaded = false;
		this.state.is_last_table_loaded = false;
		this.state.is_table_search_term_data_loaded = false;

		this.state.is_pie_table_data_loaded = false;
		this.state.is_tranction_user_type_loaded = false;
		this.state.is_event_actions_list_loaded = false;
		this.state.is_session_actions_list_loaded = false;
		this.state.is_tranction_and_event_loaded = false;
		this.state.is_sessions_and_search_loaded = false;
		this.state.is_transction_and_search_loaded = false;
		this.state.is_pie_of_pie_data_loaded = false;
		this.state.is_event_pie_data_loaded = false;



		this.getTrafficByChannelPie();
		this.getEngagementMatrices();
		this.getEngagementlinesparkgraph();
		this.getEventMatrices();
		this.getEventlinesparkgraph();

		this.getSearchMatrices();
		this.getSearchlinesparkgraph();
		this.getSearchTermsBubbleGraph();
		this.getEngagementTable();
		this.getSearchTermTable();
		this.getPieOfPieTable();
		this.getTransactions_And_User_Type();
		this.getEventActionsForTransctionAndEvent();
		this.getEventActionsForSessionAndEvent();
		this.getTransactionsAndEvent();
		this.getSessionAndSearch();
		this.getTransctionAndSearch();
		this.getSessionAndEvent();
		this.getEventBreakDownPieOfPie();

		this.forceUpdate();
		// this.datepickerHandleCallback2();
	};

	// datepickerHandleCallback2 = () => {
	//     this.setState({ isDatePickerOpen: !this.state.isDatePickerOpen });
	// };

	handleScroll = () => {
		if (window.pageYOffset > 1) {
			if (!this.state.is_scroll) {
				this.setState({ is_scroll: true });
			}
		} else {
			if (this.state.is_scroll) {
				this.setState({ is_scroll: false });
			}
		}
	};




	render() {


		let table_header_columns = " ";
		if (this.state.table_group === 'device_category') {
			table_header_columns = this.state.table_header_device_category;
		} else if (this.state.table_group === 'landing_page') {
			table_header_columns = this.state.table_header_landing_page;
		} else if (this.state.table_group === 'user_type') {
			table_header_columns = this.state.user_type;
		}
		else {
			table_header_columns = this.state.table_header_device_category;

		}

		const CarouselSettings = {
			arrows: true,
			dots: false,
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			initialSlide: 0,
			responsive: [

				{
					breakpoint: 1202,
					settings: {
						arrows: true,
						slidesToShow: 4,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 800,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,

					}
				},
				{
					breakpoint: 480,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,

					}
				}
			]
		}
		return (
			<Wrapper>
				<div className="grid grid_cols_4 drawer_grid ri_summary_bsImport">
					<div className="left_drawer col_span_1 fixed-left-grid mapRightWrapper">
						<div className="icz-rimapsection bg-white">
							<Col sm={12} className="icz-cardheader p-20 d-flex">
								<Col className="icz-cardtitle">
									<div className="icz-title-wrap p-0">
										<div className="text-left">
											<h5 className="icz-cardtitle text-start mb-0">Sales By</h5>
										</div>
									</div>
								</Col>
							</Col>

							{this.state.is_pie_data_loaded == true ?
								this.state.trafficpievalue.length === 0 ?
									<div className="h-100 d-flex justify-content-center align-items-center">
										<NoDataAvailable />
									</div>
									:
									<div className="h-100 d-flex justify-content-center align-items-center">
										<Piechart card_id="icz-traffic-piechart" card_class="icz-leftsectionchart" graph-data={this.state.trafficpievalue} parentCallback={this.handlePieclick} />
									</div>
								: <Loader />}
						</div>
					</div>
					<div className="right_side col_span_3 relative-right-grid icz-ridatacontainer">
						<div className="content">
							<div className="content_section">
								<PageHeader pageTitle={"Engagement"} />
								<div className="page_content">
									<div className="grid grid_cols_1 dashboard_home">
										<div className="grid grid_cols_1">
											<div className="grid col_span_4 icz-carouselcontainer">
												{this.state.is_engagement_metrices_loaded == true && this.state.is_engagement_lines_park_graph_loaded == true ?
													<Carousel
														Settings={CarouselSettings}
														class={"icz-cardcontainer"}
														SliderCards={[
															<ChartCard
																index="1"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Sessions"
																RowOneCurrentValue={this.state.current_session}
																RowOnePreviousValue={this.state.last_session}
																RowOneTitle="engagement"
																IsNumber={"number"}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz-sessions" card_class="icz-cardchart" graph-data={this.state.sessions_spark_graph} />}
															/>,

															<ChartCard
																index="2"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="No.Of Sessions Per User"
																RowOneCurrentValue={this.state.current_sessions_per_user.toFixed(2)}
																RowOnePreviousValue={this.state.last_sessions_per_user.toFixed(2)}
																RowOneTitle="engagement"
																IsNumber={"number"}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz-sessions-users" card_class="icz-cardchart" graph-data={this.state.sessions_per_user_spark_graph} />}
															/>,
															<ChartCard
																index="3"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Bounce Rate"
																RowOneCurrentValue={this.state.current_bounce_rate.toFixed(2)}
																RowOnePreviousValue={this.state.last_bounce_rate.toFixed(2)}
																RowOneTitle="engagement"
																IsNumber={"percentage"}
																IsStandard={false}
																chart={<Linegraph_sparkline card_id="icz-bounce-rate" isnumber={"decimal_percentage"} card_class="icz-cardchart" graph-data={this.state.bounce_rate_spark_graph} />}
															/>,
															<ChartCard
																index="5"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Avg Session Duration"
																RowOneCurrentValue={this.state.current_average_session_duration.toFixed(2)}
																RowOnePreviousValue={this.state.last_average_session_duration.toFixed(2)}
																RowOneTitle="engagement"
																IsNumber={"number"}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz-avg-session" card_class="icz-cardchart" graph-data={this.state.average_session_duration_spark_graph} />}
															/>,
															<ChartCard
																index="6"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Avg Pages Per Session"
																RowOneCurrentValue={this.state.current_average_pages_per_session.toFixed(2)}
																RowOnePreviousValue={this.state.last_average_pages_per_session.toFixed(2)}
																RowOneTitle="engagement"
																IsNumber={"number"}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz-avgpage-session" card_class="icz-cardchart" graph-data={this.state.average_pages_per_session_spark_graph} />}
															/>
														]}>

													</Carousel>
													:
													<Loader />}
											</div>
										</div>

										<div
											className="grid grid_cols_4 fullpage_section_card section_card"
										>
											<div className="grid col_span_4">
												<div className="section_card_header">
													<h2 className="section_card_title">
														Transactions by User Type
													</h2>
													<div className='icz-cardfilter'>
														<DailydataDropdown dropdown_options={this.state.dropdown_options} dropdown_placeholder="All User" parentCallback={this.handleCallback} selected_options={this.state.dropdown_options[0]} />
														<div className="icz-cardbtnwrapper icz-chartexport">
															<ChartExport
																ChartId='transactionUserType'
																export_data={this.state.tranction_user_type_list}
																downloadName="Transactions by User Type"
															/>
														</div>
													</div>
												</div>
											</div>
											<div className="grid col_span_4">
												<div className="section_card_body">
													<div className="section_card_chart_wrapper">
														{this.state.is_tranction_user_type_loaded || this.state.is_tranction_new_user_type_loaded ?
															this.state.tranction_user_type_list.length === 0 ?
																<NoDataAvailable />
																:
																<MultipleValueAxes chart_id="transactionUserType" chart_class="icz-sectionchart" graph_data={this.state.tranction_user_type_list} metric_1={"All Visitors"}
																	metric_2={this.state.user_type && this.state.user_type != 'All Visitor' ? this.state.user_type + 's' : null}

																/>
															: <Loader />}
													</div>
												</div>
											</div>
										</div>



										<Col sm={12}>
											<div className="icz-row">
												<Col><h5 className="icz-card-title align-items-start">Events</h5></Col>
												<Col className="align-items-end text-end"><Link to='/ecom/realtime' className="icz-link">
													View More </Link>
												</Col>
											</div>
										</Col>

										<div className="grid grid_cols_1">
											<div className="grid col_span_4 icz-carouselcontainer">
												{this.state.is_event_spark_line_graph_loaded == true && this.state.is_event_matrices_loaded == true ?
													<Carousel
														Settings={CarouselSettings}
														class={"icz-cardcontainer"}
														SliderCards={[
															<ChartCard
																index="1"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Sessions With Events"
																RowOneCurrentValue={this.state.current_sessions_with_event}
																RowOnePreviousValue={this.state.last_sessions_with_event}
																RowOneTitle="event"
																IsNumber={"number"}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz_sessions_events" card_class="icz-cardchart" graph-data={this.state.sessions_with_event_graph} />}
															/>,

															<ChartCard
																index="2"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Total Events Triggered"
																RowOneCurrentValue={this.state.current_total_events}
																RowOnePreviousValue={this.state.last_total_events}
																RowOneTitle="event"
																IsNumber={"number"}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz-totalevent-triggerend" card_class="icz-cardchart" graph-data={this.state.total_events_graph} />}
															/>,
															<ChartCard
																index="3"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Unique Events Triggered"
																RowOneCurrentValue={this.state.current_unique_events}
																RowOnePreviousValue={this.state.last_unique_events}
																RowOneTitle="event"
																IsNumber={"number"}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz-uniqueevent-triggerend" card_class="icz-cardchart" graph-data={this.state.unique_events_graph} />}
															/>,
														]}>

													</Carousel>
													: <Loader />}

											</div>
										</div>

										<div className="grid grid_cols_4">
											<div className="grid col_span_2 icz-sectioncardwrapper">
												<div className="icz-sectioncard">
													<Col sm={12} className="icz-cardheader flex-wrap">
														<Col lg={6} className="icz-cardtitle">
															Transactions And Events
														</Col>
														<Col lg={6} className="icz-cardfilter">
															{this.state.is_event_actions_list_loaded == true ?
																<DailydataDropdown dropdown_options={this.state.event_actions_list} dropdown_placeholder="All Events" parentCallback={this.handleMentionWordCallback} selected_options={this.state.event_actions_list[0]} />
																: <Loader />}

															<div className="icz-cardbtnwrapper icz-chartexport">
																<ChartExport
																	ChartId='transactionEvents'
																	export_data={this.state.tranction_and_event_graph}
																	downloadName=" Transactions And Events"
																/>
															</div>

														</Col>
													</Col>
													{this.state.is_tranction_and_event_loaded == true ?
														this.state.tranction_and_event_graph.length === 0 ?
															<NoDataAvailable />
															:
															<div className="">
																<MultipleValueAxes chart_id="transactionEvents" chart_class="icz-sectionchart" graph_data={this.state.tranction_and_event_graph} metric_1={this.state.event_action ? ((this.state.event_action).replace('(', '')).replace(')', '').replace(',', '').replace("'", "").replace("'", "").replace("_", " ").replace("_", " ").replace("_", " ") : 'All Events'} metric_2={"Transactions"} />
															</div>
														: <Loader />}
												</div>
											</div>
											<div className="grid col_span_2 icz-sectioncardwrapper">
												<div className="icz-sectioncard">
													<Col sm={12} className="icz-cardheader flex-wrap">
														<Col lg={6} className="icz-cardtitle">
															Sessions And Events
														</Col>
														<Col lg={6} className="icz-cardfilter">
															{this.state.is_session_actions_list_loaded == true ?
																<DailydataDropdown dropdown_options={this.state.session_actions_list} dropdown_placeholder="All Events" parentCallback={this.handleSessionWordCallback} selected_options={this.state.session_actions_list[0]} />
																: <Loader />}

															<div className="icz-cardbtnwrapper icz-chartexport">
																<ChartExport
																	ChartId='sessionsEvents'
																	export_data={this.state.sessions_and_event_graph}
																	downloadName="Sessions And Events"
																/>
															</div>
														</Col>
													</Col>
													{this.state.is_sessions_and_event_loaded == true ?
														this.state.sessions_and_event_graph.length === 0 ?
															<NoDataAvailable />
															:
															<div className="">
																<MultipleValueAxes chart_id="sessionsEvents" chart_class="icz-sectionchart" graph_data={this.state.sessions_and_event_graph} metric_1={this.state.event_action_1 ? ((this.state.event_action_1).replace('(', '')).replace(')', '').replace(',', '').replace("'", "").replace("'", "").replace("_", " ").replace("_", " ").replace("_", " ") : 'All Events'} metric_2={"Sessions"} />
															</div>
														: <Loader />}
												</div>
											</div>
										</div>

										<div className="grid grid_cols_1" >
											<Col className="icz-sectioncardwrapper" sm={12} lg={12}  >
												<div className="icz-sectioncard">
													<Col sm={12} className="icz-cardheader flex-wrap justify-content-between">
														<Col lg={8} className="icz-cardtitle">
															Event Breakdown
														</Col>
														<Col lg={4} className="icz-cardfilter">
															<button className="icz-btn" onClick={this.eventShow} >Know More</button>

															<div className="icz-cardbtnwrapper icz-chartexport">
																<ChartExport
																	ChartId='eventBreakdown'
																	export_data={this.state.pieofpiechartdata}
																	downloadName="Event Breakdown"
																/>
															</div>
														</Col>
													</Col>
													{this.state.is_pie_of_pie_data_loaded ?
														this.state.pieofpiechartdata.length == 0 ?
															<NoDataAvailable />
															:
															<div className="">
																<PieOfPieChart chart_id="eventBreakdown" chart_class="icz-sectionchart" graph-data={this.state.pieofpiechartdata} />                                                </div>
														: <Loader />}
												</div>
											</Col>
										</div>

										{this.state.isActive &&
											<div className='grid grid_cols_1 icz-sectioncardwrapper' ref={this.scrollDiv}>
												{/* <Col className="icz-sectioncardwrapper" sm={12} lg={12}  > */}
												<div className="icz-sectioncard"
													style={{ overflowX: 'hidden' }}
												>
													<Col sm={12} className="icz-cardheader flex-wrap justify-content-between">
														<Col lg={4} sm={8} className="icz-cardtitle">
															Transactions And Events
														</Col>
														<Col lg={8} className="icz-cardfilter">
															<button className="icz-btn" onClick={this.eventHide}>Close</button>

															<div className="icz-cardbtnwrapper icz-chartexport">
																<ChartExport
																	ChartId='transactionsAndEvents'
																	export_data={this.state.table_events_data}
																	downloadName="Transactions And Events"
																/>
															</div>
														</Col>
													</Col>

													{this.state.is_pie_table_data_loaded == true ?
														this.state.table_events_data.length === 0 ?
															<NoDataAvailable />
															:
															<div id='transactionsAndEvents' className=" icz-table">
																<DataTable isTableTitleEnable={true} isSearchEnable={false} Headers={this.state.table_events} isPageInfoEnable={true} TableSize={5} TableData={this.state.table_events_data} />
															</div>
														: <Loader />}
												</div>
												{/* </Col> */}
											</div>
										}

										{/* <span ref={this.scrollDiv}></span> */}

										<div className="grid grid_cols_1 icz-title-wrap d-flex" >
											<Col sm={12}>
												<div className="icz-row">
													<Col><h5 className="icz-card-title align-items-start">Internal Search</h5></Col>
												</div>
											</Col>
										</div>

										<div className="grid grid_cols_1">
											<div className="grid col_span_4 icz-carouselcontainer">

												{this.state.is_search_matrices_data_loaded == true && this.state.is_search_lines_park_graph_data_loaded == true ?
													<Carousel
														Settings={CarouselSettings}
														class={"icz-cardcontainer"}
														SliderCards={[
															// <ChartCard
															//     index="1"
															//     CardClass="icz-cardwrapper"
															//     CardIcon={<IconWebsite className="icz-icon" />}
															//     CardTitle=" % Sessions With Search"
															//     RowOneCurrentValue="2800000"
															//     RowOnePreviousValue="80000"
															//     RowOneTitle="search"
															//     IsNumber={true}
															//     chart={<Linegraph_sparkline card_id="icz-sessions-search" card_class="icz-cardchart" graph-data={this.state.linesparkgraph} />}
															// />,

															<ChartCard
																index="2"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Total Unique Searches"
																RowOneCurrentValue={(this.state.current_search_uniques ? this.state.current_search_uniques.toFixed() : 0)}
																RowOnePreviousValue={this.state.last_search_uniques}
																RowOneTitle="search"
																IsNumber={'number'}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz-totalunique-search" card_class="icz-cardchart" graph-data={this.state.total_unique_search_graph} />}
															/>,
															<ChartCard
																index="3"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Avg Search Depth"
																RowOneCurrentValue={this.state.current_avg_search_depth.toFixed(2)}
																RowOnePreviousValue={this.state.last_avg_search_depth.toFixed(2)}
																RowOneTitle="search"
																IsNumber={'number'}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz-avgsearch-depth" card_class="icz-cardchart" graph-data={this.state.avg_search_depth_graph} />}
															/>,
															<ChartCard
																index="4"
																CardClass="icz-cardwrapper"
																CardIcon={<IconWebsite className="icz-icon" />}
																CardTitle="Avg Time After Search"
																RowOneCurrentValue={this.state.current_avg_time_after_search.toFixed(2)}
																RowOnePreviousValue={this.state.last_avg_time_after_search.toFixed(2)}
																RowOneTitle="search"
																IsNumber={'number'}
																IsStandard={true}
																chart={<Linegraph_sparkline card_id="icz-avg-timesearch" card_class="icz-cardchart" graph-data={this.state.avg_time_after_search_graph} />}
															/>,

														]}>

													</Carousel>
													: <Loader />}
											</div>
										</div>

										<div className="grid grid_cols_4">
											<div className='grid col_span_2 icz-sectioncardwrapper'>
												<div className="icz-sectioncard">
													<Col sm={12} className="icz-cardheader">
														<Col className="icz-cardtitle">
															Transactions And Internal Search
														</Col>
														<Col className="icz-cardfilter icz-chartexport">
															<div className="icz-cardbtnwrapper">
																<ChartExport
																	ChartId='transactionInternalSearch'
																	export_data={this.state.transction_and_search_graph}
																	downloadName=" Transactions And Internal Search"
																/>
															</div>
														</Col>
													</Col>

													{this.state.is_transction_and_search_loaded == true ?
														this.state.transction_and_search_graph.length === 0 ?
															<NoDataAvailable />
															:
															<div className="">
																<MultipleValueAxes chart_id="transactionInternalSearch" chart_class="icz-sectionchart" graph_data={this.state.transction_and_search_graph} metric_1={"Search"} metric_2={"Transactions"} />
															</div>
														: <Loader />}
												</div>
											</div>
											<div className='grid col_span_2 icz-sectioncardwrapper'>
												<div className="icz-sectioncard">
													<Col sm={12} className="icz-cardheader">
														<Col className="icz-cardtitle">
															Sessions And Internal Search
														</Col>
														<Col lg={2} className="icz-cardfilter icz-chartexport">
															<div className="icz-cardbtnwrapper">
																<ChartExport
																	ChartId='sessionsInternalSearch'
																	export_data={this.state.sessions_and_search_graph}
																	downloadName="Sessions And Internal Search"
																/>
															</div>
														</Col>
													</Col>
													{this.state.is_sessions_and_search_loaded == true ?
														this.state.sessions_and_search_graph.length === 0 ?
															<NoDataAvailable />
															:
															<div className="">
																<MultipleValueAxes chart_id="sessionsInternalSearch" chart_class="icz-sectionchart" graph_data={this.state.sessions_and_search_graph} metric_1={"Search"} metric_2={"Sessions"} />
															</div>
														: <Loader />}
												</div>
											</div>
										</div>

										<div className="grid grid_cols_1">

											<Col className="icz-sectioncardwrapper" sm={12} lg={12}>
												<div className="icz-sectioncard">
													<Col sm={12} className="icz-cardheader flex-wrap justify-content-between">
														<Col lg={4} className="icz-cardtitle">
															Search Terms
														</Col>
														<Col lg={8} className="icz-cardfilter">
															<button className="icz-btn" onClick={this.searchShow}>Know More</button>
															<div className="icz-cardbtnwrapper  icz-chartexport">
																<ChartExport
																	ChartId='search_terms_chart'
																	export_data={this.state.search_terms_bubble_graph}
																	downloadName="Search Terms"
																/>
															</div>
														</Col>
													</Col>

													{this.state.is_bubble_graph_data_loaded == true ?
														this.state.search_terms_bubble_graph.length === 0 ?
															<NoDataAvailable />
															:
															<div className="">
																<BubbleTextchart card_id="search_terms_chart" card_class="icz-sectionchart" isnumber={'money'} metric_1={"Average Order Value"} metric_2={"Transactions"} tooltip_label={"Unique Searches"} graph-data={this.state.search_terms_bubble_graph} />
															</div>
														: <Loader />}
												</div>
											</Col>

										</div>

										{this.state.show ?
											<div className="grid grid_cols_1">
												<Col className="icz-sectioncardwrapper" sm={12} lg={12}>
													<div className="icz-sectioncard">
														<Col sm={12} className="icz-cardheader flex-wrap justify-content-between">
															<Col lg={4} className="icz-cardtitle">
																Search Terms
															</Col>
															<Col lg={8} className="icz-cardfilter">
																<button className="icz-btn" onClick={this.searchHide}>Close</button>
																<div className="icz-cardbtnwrapper icz-chartexport">
																	<ChartExport
																		ChartId='search_terms'
																		export_data={this.state.table_search_term_data}
																		downloadName="Search Terms"
																	/>
																</div>
															</Col>
														</Col>
														{this.state.is_table_search_term_data_loaded == true ?
															<div id="search_terms" className="icz-searchtable icz-table">
																<DataTable isTableTitleEnable={true} isSearchEnable={false} Headers={this.state.table_search} isPageInfoEnable={true} TableSize={5} TableData={this.state.table_search_term_data} />
															</div>
															: <Loader />}
													</div>

												</Col>
											</div>
											: null}

										<div className="grid grid_cols_1 icz-sectioncardwrapper">
											<div className="icz-sectioncard" style={{ overflowX: 'hidden' }}>
												<Col sm={12} className="icz-cardheader flex-wrap justify-content-between">
													<Col lg={8} className="icz-cardtitle">
														Engagement Details
													</Col>
													<Col lg={4} className="icz-cardfilter">
														<DailydataDropdown dropdown_options={this.state.datatabledropdown_options} parentCallback={this.handledatatableCallback} selected_options={this.state.datatabledropdown_options[0]} />
													</Col>
												</Col>

												{this.state.is_last_table_loaded == true ?
													<div className="icz-table">
														<DataTable isTableTitleEnable={true} isSearchEnable={false} Headers={table_header_columns} isPageInfoEnable={true} TableSize={5} TableData={this.state.last_table_values} />
													</div>
													: <Loader />}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>


			</Wrapper>
		)
	}
}

function ReduxStateToProps(state) {
	return {
		start_date: state.date.startDate,
		end_date: state.date.endDate,
		previous_start_date: state.date.prevStartDate,
		previous_end_date: state.date.prevEndDate,
	};
}

export default connect(ReduxStateToProps)(Engagement)